module.exports = __webpack_public_path__ + "static/media/telegram.61e0d042.svg";